import React, { useState } from "react";
import logo from "./images/logo.png";
import { IoIosLogIn } from "react-icons/io";
import { FaRegUser } from "react-icons/fa";

const NormalNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="relative">
      {/* Header */}
      <header className="fixed top-4 left-1/2 transform -translate-x-1/2 w-[90%] lg:w-3/4 max-w-6xl bg-black text-white px-6 py-3 lg:px-8 lg:py-5 rounded-full z-50 flex justify-between items-center shadow-md">
        {/* Logo */}
        <div className="flex items-center gap-4">
          <img src={logo} alt="Logo" className="w-8 h-8" />
          <span className="hidden md:inline text-xl font-bold">Porche</span>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={handleMenuToggle}
          className="text-white bg-gray-700 px-3 py-2 rounded hover:bg-gray-600 md:hidden"
          aria-label="Toggle Menu"
        >
          ☰
        </button>

        {/* Desktop Menu Links and Icons */}
        <nav className="hidden md:flex gap-12 lg:gap-16 items-center text-lg">
          <a
            href="#home"
            className="hover:text-gray-400 transition transform hover:scale-105"
          >
            Home
          </a>
          <a
            href="#about"
            className="hover:text-gray-400 transition transform hover:scale-105"
          >
            About
          </a>
          <a
            href="#services"
            className="hover:text-gray-400 transition transform hover:scale-105"
          >
            Services
          </a>
          <a
            href="#contact"
            className="hover:text-gray-400 transition transform hover:scale-105"
          >
            Contact
          </a>

          {/* Icons */}
          <div className="flex gap-6 lg:gap-12 items-center">
            <FaRegUser className="text-2xl hover:text-gray-400 transition transform hover:scale-110" />
            <IoIosLogIn className="text-3xl hover:text-gray-400 transition transform hover:scale-110" />
          </div>
        </nav>
      </header>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div
          className="absolute top-20 left-1/2 transform -translate-x-1/2 w-[85%] max-w-sm bg-black text-white py-4 shadow-lg rounded-lg md:hidden"
        >
          <nav className="flex flex-col gap-4 text-center">
            <a
              href="#home"
              className="hover:text-gray-400 transition transform hover:scale-105"
              onClick={handleMenuToggle}
            >
              Home
            </a>
            <a
              href="#about"
              className="hover:text-gray-400 transition transform hover:scale-105"
              onClick={handleMenuToggle}
            >
              About
            </a>
            <a
              href="#services"
              className="hover:text-gray-400 transition transform hover:scale-105"
              onClick={handleMenuToggle}
            >
              Services
            </a>
            <a
              href="#contact"
              className="hover:text-gray-400 transition transform hover:scale-105"
              onClick={handleMenuToggle}
            >
              Contact
            </a>
          </nav>
        </div>
      )}
    </div>
  );
};

export default NormalNavbar;

